import { bool, func, number } from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Label, Row } from 'reactstrap';

import Association from '../../../associations/Association';
import CurrencyInput from '../../../generic/CurrencyInput';
import getInfoTooltip from '../../../generic/Tooltip/get-info-tooltip';
import { opportunityShape } from '../../../prop-types';
import removeIndex from '../../../utils/remove-index';
import HELP_TEXTS from '../../help-texts';

class AgreementOpportunities extends Component {
  handleLinkNewAgreement = () => {
    const {
      opportunity: { agreementOpportunities },
      onChange,
    } = this.props;
    return onChange({
      target: {
        name: `agreementOpportunities.${agreementOpportunities.length}`,
        value: { agreement: null, budget: 0 },
      },
    });
  };

  handleAgreementRemoval(index) {
    const {
      onChange,
      opportunity: { agreementOpportunities },
    } = this.props;
    onChange({
      target: {
        name: 'agreementOpportunities',
        value: removeIndex(agreementOpportunities, index),
      },
    });
  }

  render() {
    const {
      opportunity: { agreementOpportunities },
      readOnly,
      onChange,
      currentAgreementId,
    } = this.props;
    if (!agreementOpportunities.length && readOnly) {
      return 'No linked agreements';
    }

    const inputProps = { onChange, readOnly };
    return (
      <>
        {agreementOpportunities.length ? (
          <Row>
            <Label sm={7} for="op-agreements">
              Name
            </Label>
            <Label sm={4} for="op-agreements">
              Budget
              {getInfoTooltip(HELP_TEXTS, 'budget', 'agreements')}
            </Label>
          </Row>
        ) : (
          ''
        )}
        {agreementOpportunities.map(({ id, agreement, budget }, index) => {
          const isCurrentAgreement = agreement === currentAgreementId;
          const isCurrentAgreementReadOnly = readOnly || isCurrentAgreement;
          return (
            <Row className="mb-3" key={id}>
              <Col sm={7}>
                <Association
                  name={`agreementOpportunities[${index}].agreement`}
                  type="agreement"
                  className="form-control-plaintext-without-color-override text-overflow--ellipsis"
                  {...inputProps}
                  value={agreement}
                  readOnly={readOnly || isCurrentAgreement}
                />
              </Col>
              <Col sm={readOnly ? 5 : 4}>
                <CurrencyInput
                  name={`agreementOpportunities[${index}].budget`}
                  value={budget}
                  {...inputProps}
                />
              </Col>
              <Col sm={1}>
                {!isCurrentAgreementReadOnly && (
                  <Button
                    close
                    onClick={() => this.handleAgreementRemoval(index)}
                  />
                )}
              </Col>
            </Row>
          );
        })}
        {!readOnly && (
          <Button onClick={this.handleLinkNewAgreement}>
            Link a new agreement
          </Button>
        )}
      </>
    );
  }
}

AgreementOpportunities.propTypes = {
  onChange: func,
  readOnly: bool.isRequired,
  opportunity: opportunityShape.isRequired,
  currentAgreementId: number,
};

AgreementOpportunities.defaultProps = {
  onChange: () => {},
  currentAgreementId: undefined,
};

export default AgreementOpportunities;
